import React, { useEffect, useState, Fragment } from "react";
import { resetPasswordService } from "../../../store/services/ServiceResetPassword";
import { userProfileService } from "../../../store/services/ServiceUserProfile";
import {
    isEmpty,
    isPasswordError,
    isRepeatPasswordError,
} from "../../../store/services/helpers/validation";
import ButtonSubmit from "../../../components/buttons/ButtonSubmit";
import ModalResponse from "../../../components/modals/ModalResponse";
import { Form, Grid, Header } from "semantic-ui-react";

function ProfileChangePassword() {
    const [hasPassword, setHasPassword] = useState(null);
    const [oldPassword, setOldPassword] = useState("");
    const [password, setPassword] = useState("");
    const [repeatPassword, setRepeatPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalIsError, setModalIsError] = useState(false);
    const [modalMessage, setModalMessage] = useState("");

    useEffect(() => {
        const load = async () => {
            const dataProfile = await userProfileService.getUserProfile();
            const profile = dataProfile && dataProfile[0];
            setHasPassword(profile ? !!profile.has_password : true);
        };
        load();
    }, []);

    const openModal = (message, error) => {
        setModalMessage(message);
        setModalIsError(error);
        setIsLoading(false);
        setModalOpen(true);
    };

    const handleSetPassword = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        if (isPasswordError(password) || isRepeatPasswordError(password, repeatPassword)) {
            setIsLoading(false);
            return;
        }
        const saved = await resetPasswordService.setInitialPassword(password);
        if (!saved) {
            openModal("Bezpečnostné heslo sa nepodarilo nastaviť.", true);
            return;
        }
        setHasPassword(true);
        setPassword("");
        setRepeatPassword("");
        openModal("Bezpečnostné heslo je nastavené. Odteraz sa ním vieš prihlásiť.", false);
    };

    const handleChangePassword = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        if (
            oldPassword === "" ||
            isRepeatPasswordError(password, repeatPassword) ||
            isPasswordError(password)
        ) {
            setIsLoading(false);
            return;
        }
        const saved = await resetPasswordService.setNewPassword({
            new_password: password,
            current_password: oldPassword,
        });
        if (!saved) {
            openModal("Počas zmeny hesla došlo k chybe!", true);
            return;
        }
        setOldPassword("");
        setPassword("");
        setRepeatPassword("");
        openModal("Zmena hesla prebehla úspešne.", false);
    };

    return (
        <Fragment>
            <Grid>
                <Grid.Column computer={8} tablet={8} mobile={16}>
                    {hasPassword === null ? null : hasPassword ? (
                        <Fragment>
                            <Header as="h3">ZMENA HESLA</Header>
                            <Form onSubmit={handleChangePassword}>
                                <Form.Input
                                    required
                                    fluid
                                    label="Staré heslo"
                                    placeholder="Staré heslo"
                                    type="password"
                                    autoComplete="new-password"
                                    value={oldPassword}
                                    onChange={(e) => setOldPassword(e.target.value)}
                                />
                                <Form.Input
                                    required
                                    fluid
                                    label="Nové heslo"
                                    placeholder="Nové heslo"
                                    type="password"
                                    autoComplete="new-password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    error={!isEmpty(password) ? isPasswordError(password) : false}
                                />
                                <Form.Input
                                    required
                                    fluid
                                    label="Opakuj heslo"
                                    placeholder="Opakuj heslo"
                                    type="password"
                                    autoComplete="new-password"
                                    value={repeatPassword}
                                    onChange={(e) => setRepeatPassword(e.target.value)}
                                    error={!isEmpty(repeatPassword) ? isRepeatPasswordError(password, repeatPassword) : false}
                                />
                                <ButtonSubmit
                                    loading={isLoading}
                                    disabled={isLoading || isEmpty(oldPassword) || isEmpty(password) || isEmpty(repeatPassword)}
                                    text="Zmeniť heslo"
                                />
                            </Form>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <Header as="h3">BEZPEČNOSTNÉ HESLO</Header>
                            <p>Účet je prihlásený cez Google. Heslo zatiaľ nie je nastavené.</p>
                            <Form onSubmit={handleSetPassword}>
                                <Form.Input
                                    required
                                    fluid
                                    label="Nové heslo"
                                    placeholder="Nové heslo"
                                    type="password"
                                    autoComplete="new-password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    error={!isEmpty(password) ? isPasswordError(password) : false}
                                />
                                <Form.Input
                                    required
                                    fluid
                                    label="Opakuj heslo"
                                    placeholder="Opakuj heslo"
                                    type="password"
                                    autoComplete="new-password"
                                    value={repeatPassword}
                                    onChange={(e) => setRepeatPassword(e.target.value)}
                                    error={!isEmpty(repeatPassword) ? isRepeatPasswordError(password, repeatPassword) : false}
                                />
                                <ButtonSubmit
                                    loading={isLoading}
                                    disabled={isLoading || isEmpty(password) || isEmpty(repeatPassword)}
                                    text="Nastaviť heslo"
                                />
                            </Form>
                        </Fragment>
                    )}
                </Grid.Column>
            </Grid>
            <ModalResponse
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                icon={modalIsError ? "warning circle" : "checkmark"}
                header={modalIsError ? "Aktualizácia neúspešná" : "Aktualizácia úspešná"}
                message={modalMessage}
                onClick={() => setModalOpen(false)}
            />
        </Fragment>
    );
}

export default ProfileChangePassword;
